var _path, _rect, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnrestricted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 46,
    viewBox: "0 0 41 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.166 18.5H9.16602V13C9.16602 6.92433 14.0903 2 20.166 2C26.2417 2 31.166 6.92433 31.166 13V18.5Z",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 10,
    width: 4,
    height: 7,
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6667 16.666H3.66667C1.64083 16.666 0 18.3068 0 20.3327V42.3327C0 44.3585 1.64083 45.9993 3.66667 45.9993H36.6667C38.6925 45.9993 40.3333 44.3585 40.3333 42.3327V20.3327C40.3333 18.3068 38.6925 16.666 36.6667 16.666ZM20.1667 34.9993C18.1408 34.9993 16.5 33.3567 16.5 31.3327C16.5 29.3068 18.1408 27.666 20.1667 27.666C22.1925 27.666 23.8333 29.3068 23.8333 31.3327C23.8333 33.3567 22.1925 34.9993 20.1667 34.9993ZM31.1667 34.9993C29.1408 34.9993 27.5 33.3567 27.5 31.3327C27.5 29.3068 29.1408 27.666 31.1667 27.666C33.1925 27.666 34.8333 29.3068 34.8333 31.3327C34.8333 33.3567 33.1925 34.9993 31.1667 34.9993ZM9.16667 34.9993C7.14083 34.9993 5.5 33.3567 5.5 31.3327C5.5 29.3068 7.14083 27.666 9.16667 27.666C11.1925 27.666 12.8333 29.3068 12.8333 31.3327C12.8333 33.3567 11.1925 34.9993 9.16667 34.9993Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnrestricted);
export default __webpack_public_path__ + "static/media/Unrestricted.a84d50470e7cf81a128dcd0d20fe3286.svg";
export { ForwardRef as ReactComponent };